<template>
  <div class="container">
    <div class="flex c-items-center c-px-3 c-py-4 c-md:c-p-4 c-mb-4 c-lg:c-p-5 bg-white c-rounded-lg shadow row">
      <div class="c-md:col-7 col-12">
        <div class="row">
          <div class="col-2">
            <BirdToRight
              class="w-100 h-auto"
              type="search"
            />
          </div>
          <div class="col-10">
            <h3 class="h3 c-mb-2">
              {{ t('this_product_is_no_available') }}
            </h3>
            <p class="text-sm-c">
              {{ t('with_this_substitute') }}
            </p>
          </div>
        </div>
      </div>
      <div class="c-md:col-5 col-12">
        <div class="row bg-white c-rounded-lg shadow c-py-2">
          <div class="col-3">
            <RemoteResponsiveImage
              :product-image-data="sortedProductImages[0].data"
              img-class="c-mb-4 c-lg:c-mb-3 bock w-100"
              :alt="product.name"
            />
          </div>
          <div class="col-9">
            <h4 class="h4 c-mb-2">
              {{ product.name }}
            </h4>
            <router-link
              class="btn  c-py-1 c-px-2 c-mb-2 btn-success c-rounded-pill font-medium stretched-link whitespace-nowrap"
              :to="{ name: 'productPath', params: { permalink: product.permalink } }"
            >
              <i class="mi-cart icon-20 c-mr-2 c-sm:c-mr-1 hidden c-lg:block" /> 
              {{ t('want_to_see') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import BirdToRight from '@/components/svg/birds/BirdToRight.vue'

const { t } = useI18n()

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
})

const sortedProductImages = computed(() => {
  return [...props.product.images].sort((a, b) => Number(b.main_image) - Number(a.main_image))
})
</script>

<i18n>
  {
    "cs": {
    "this_product_is_no_available": "Tento produkt má už svého nástupce.",
    "want_to_see": "Chci se kouknout",
    "with_this_substitute": "Snad vás potěšíme tímto náhradníkem. "
},
    "sk": {
    "this_product_is_no_available": "Tento produkt už má svojho nástupcu.",
    "want_to_see": "Chcem sa pozrieť",
    "with_this_substitute": "Snáď Vás potešíme týmto náhradníkom."
},
    "pl": {
    "this_product_is_no_available": "Ten produkt nie jest już dostępny.",
    "want_to_see": "Chcę zobaczyć",
    "with_this_substitute": "Liczymy, że jego nowa wersja przypadnie Ci do gustu."
},
    "hu": {
    "this_product_is_no_available": "Ez a termék már nem elérhető :-(",
    "want_to_see": "Megnézem",
    "with_this_substitute": "Reméljük termékajánlatunkkal kedvedben járunk :-)"
},
    "de": {
    "this_product_is_no_available": "Dieses Produkt hat bereits einen Nachfolger. ",
    "want_to_see": "Jetzt entdecken!",
    "with_this_substitute": "Dieser Nachfolger gefälllt dir hoffentlich auch. :-)"
},
    "at": {
    "this_product_is_no_available": "Dieses Produkt hat bereits einen Nachfolger. ",
    "want_to_see": "Jetzt entdecken!",
    "with_this_substitute": "Dieser Nachfolger gefälllt dir hoffentlich auch. :-)"
},
    "ro": {
    "this_product_is_no_available": "Acest produs are un înlocuitor. ",
    "want_to_see": "Vreau să văd",
    "with_this_substitute": "Sperăm că veți fi mulțumit de acest înlocuitor. "
},
    "fr": {
    "this_product_is_no_available": "Ce produit a déjà son successeur.",
    "want_to_see": "Je veux jeter un œil",
    "with_this_substitute": "Nous espérons que ce remplaçant vous plaira."
},
    "it": {
    "this_product_is_no_available": "Questo prodotto ha già un successore.",
    "want_to_see": "Voglio dare un'occhiata",
    "with_this_substitute": "Speriamo che questo sostituto ti piaccia."
}
  }
</i18n>
